import api from './api'

export const listCalendarEvents = async ({ start, end, productId, status }) => {
  const params = { start, end }
  if (productId !== undefined && productId !== null && productId !== '') {
    params.productId = productId
  }
  if (status) {
    params.status = status
  }
  const response = await api.get('/calendar', { params })
  return response.data
}

export const getCalendarEvent = async (id) => {
  const response = await api.get(`/calendar/${id}`)
  return response.data
}

export const createCalendarEvent = async (payload) => {
  if (process.env.NODE_ENV === 'development') {
    console.debug('[Calendar] createEvent payload', payload)
  }
  const response = await api.post('/calendar', payload)
  return response.data
}

export const updateCalendarEvent = async (id, payload) => {
  const response = await api.put(`/calendar/${id}`, payload)
  return response.data
}

export const deleteCalendarEvent = async (id) => {
  const response = await api.delete(`/calendar/${id}`)
  return response.data
}

export const createBookingLink = async (payload) => {
  const response = await api.post('/calendar/booking-links', payload)
  return response.data
}

export const getBookingAvailability = async (token, { start, end } = {}) => {
  const response = await api.get(`/public/booking/${token}/availability`, {
    params: { start, end },
  })
  return response.data
}

export const createBooking = async (token, payload) => {
  const response = await api.post(`/public/booking/${token}/reserve`, payload)
  return response.data
}

export const cancelBooking = async (token, payload) => {
  const response = await api.post(`/public/booking/${token}/cancel`, payload)
  return response.data
}
